export default __webpack_public_path__ + "static/media/map1.8a43ae82.png";